export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gradient-to-b from-gray-900 to-gray-950 text-white py-16 mx-6 mb-6 rounded-3xl">
      <div className="max-w-7xl mx-auto px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
          <div>
            <h3 className="text-3xl font-bold mb-6 leading-tight">
              和の極みを<br />あなたの手に
            </h3>
          </div>

          <div>
            <h4 className="text-xl font-semibold mb-6">ナビゲーション</h4>
            <ul className="grid grid-cols-4 gap-x-6 gap-y-4">
              <li>
                <button
                  onClick={() => scrollToSection('lineup')}
                  className="text-gray-400 hover:text-amber-400 transition-colors cursor-pointer text-base"
                >
                  製品一覧
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('features')}
                  className="text-gray-400 hover:text-amber-400 transition-colors cursor-pointer text-base"
                >
                  特徴
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('how-to-use')}
                  className="text-gray-400 hover:text-amber-400 transition-colors cursor-pointer text-base"
                >
                  使用方法
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('kiln')}
                  className="text-gray-400 hover:text-amber-400 transition-colors cursor-pointer text-base"
                >
                  窯元紹介
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('venues')}
                  className="text-gray-400 hover:text-amber-400 transition-colors cursor-pointer text-base"
                >
                  吸える場所
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('location')}
                  className="text-gray-400 hover:text-amber-400 transition-colors cursor-pointer text-base"
                >
                  アクセス
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contact')}
                  className="text-gray-400 hover:text-amber-400 transition-colors cursor-pointer text-base"
                >
                  お問い合わせ
                </button>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-gray-800 text-center text-gray-500 text-base">
          <p>&copy; 2024 Spring Sun Bowl. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
